<div
  class="sidebar"
  [class.sidebar--expanded]="isExpanded"
  [class.sidebar--pending-persistence]="!isSidebarPersistedStateReady"
  [class.sidebar--with-custom-tenant-message]="
    customTenantMessageVisibility$ | async
  "
>
  <form
    [formGroup]="subTenantForm"
    class="sidebar__header"
    [attr.aria-label]="
      isTenantUser && isExpanded && !isAdminPage && !isFinancingPage
        ? 'Sidebar filters'
        : null
    "
  >
    @if (isTenantUser && isExpanded && !isAdminPage && !isFinancingPage) {
      <app-agility-multiselect
        class="w-full"
        inputId="selectedSubTenants"
        dataTestId="sidebar-originators-multiselect"
        ariaLabel="Filter workflows by originators"
        [options]="allSubTenants"
        optionLabel="text"
        formControlName="originatorsDropdown"
        [maxSelectedLabels]="1"
        (selectAllChange)="onMultiSelectAllChange($event)"
      >
        <ng-template #selectedItemsTemplate let-value>
          @if (value?.length === 0 || !value || !allSubTenants.length) {
            <div>Select Originators</div>
          } @else if (
            value?.length > 0 && value?.length === allSubTenants.length
          ) {
            <div>All Originators</div>
          } @else if (value?.length > 0 && allSubTenants.length) {
            <div>{{ value?.length }} Originators selected</div>
          }
        </ng-template>
      </app-agility-multiselect>
    }
    @if (isExpanded && (isAdminPage || isFinancingPage)) {
      <h4>{{ isAdminPage ? 'Admin' : 'Financing' }}</h4>
    }
    <app-agility-button
      id="sidebar-toggle-button"
      ariaLabel="Toggle sidebar"
      buttonType="button"
      variant="text"
      icon="pi pi-bars"
      (click)="toggleSidebar()"
      data-testid="sidebar-toggle-button"
    ></app-agility-button>
  </form>

  <div class="sidebar__content">
    @if (!isAdminPage && !isFinancingPage) {
      <nav aria-label="Workflow navigation">
        <div class="sidebar__workflow-view">
          @for (panel of workflowPanels; track panel.id) {
            <app-sidebar-workflow-panel
              [panel]="panel"
              [isOpen]="isPanelOpen(panel.id)"
              [isLoading]="getPanelLoader(panel.id)"
              (panelToggle)="togglePanel(panel.id)"
            />
          }
        </div>

        @if (!isExpanded) {
          <ul class="sidebar__icons">
            @for (anchor of mainSectionAnchors; track anchor.route) {
              <li>
                <a
                  [routerLink]="anchor.route"
                  [attr.aria-label]="anchor.label"
                  [pTooltip]="anchor.label"
                  tooltipPosition="right"
                >
                  <i [class]="anchor.icon" aria-hidden="true"></i>
                </a>
              </li>
            }
          </ul>
        }
      </nav>
    }

    @if (isAdminPage || isFinancingPage) {
      <app-page-sidebar-menu
        [isSidebarExpanded]="isExpanded || false"
        [selectedPageName]="selectedPageName"
      ></app-page-sidebar-menu>
    }
  </div>
</div>
